export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9951.206bbe3d.jpg";